// extracted by mini-css-extract-plugin
module.exports = {"overlay":"LoadingOverlay_overlay__k3LIP","loading":"LoadingOverlay_loading__1qCKU","spinner":"LoadingOverlay_spinner__2PM0Z"};